export class ZplSettings {
	Host:string = "";
	Port:number = 0;

	public constructor(data?:any){
		if (!data) return;
		this.Host = data.Host;
		this.Port = data.Port;
	}
	public getJSON(){
		return {
			Host: this.Host,
			Port: this.Port
		};
	}
}